// ===============================
// FRENCH TRANSLATIONS - PART 1
// AboutSec3DataFR.js
// ===============================

// DEFAULT ABOUT PAGE DATA
export const aboutDataFR = {
  subtitle: "NOTRE MISSION",
  title: "FAIRE PROGRESSER LA NORME DU CONSEIL FINANCIER MODERNE",
  rightText:
    "Nous existons pour renforcer la façon dont les organisations interprètent le risque financier, capitalisent sur les opportunités et construisent une valeur à long terme. Notre mission est enracinée dans la profondeur analytique, la discipline stratégique et la conviction que de meilleures décisions façonnent des économies plus fortes et des entreprises plus résilientes.",
  box1Title: "Réinvention des Décisions",
  box1Text:
    "Nous visons à élever la prise de décision financière grâce à la modélisation avancée, l'intelligence inter-marchés et l'évaluation basée sur des scénarios.",
  box2Title: "Ingénierie de Résilience",
  box2Text:
    "Notre mission se concentre sur l'intégration de la stabilité, de la discipline de performance et de la prévoyance des risques au cœur de chaque organisation que nous soutenons.",
  image: "/assets/images/TeamMeeting.png",
};

// AUDIT & ASSURANCE
export const financialStatementAuditDataFR = {
  subtitle: "COMPRENDRE LES AUDITS DES ÉTATS FINANCIERS",
  title: "RAPPORTS FIABLES POUR LES ENTREPRISES QUI ONT BESOIN D'UNE PRÉCISION ABSOLUE",
  rightText:
    "Nos audits découvrent les incohérences derrière les chiffres, évaluent les lacunes de contrôle et fournissent une vue claire et défendable de la position financière de votre organisation.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Notre service d'audit des états financiers est conçu pour valider l'exactitude, l'équité et la conformité des informations financières.",
  box2Title: "NOS AUDITEURS EXPÉRIMENTÉS",
  box2Text:
    "Nous renforçons les processus faibles et garantissons que vos états répondent aux normes IFRS, GAAP et à toutes les attentes réglementaires sans surprises.",
  image: "/assets/images/TeamMeeting.png",
};

export const ifrsAdvisoryServiceDataFR = {
  subtitle: "À PROPOS DU SERVICE IFRS",
  title: "RAPPORTS PRÉCIS, CONFORMES ET ALIGNÉS À L'ÉCHELLE MONDIALE",
  rightText:
    "Nous aidons les organisations à interpréter les exigences IFRS, à repenser les structures de reporting et à préparer des divulgations prêtes pour les régulateurs.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Notre objectif est d'aider les organisations à interpréter les exigences IFRS, à repenser les structures de reporting financier et à préparer des divulgations qui satisfont les régulateurs et les investisseurs.",
  box2Title: "NOS SPÉCIALISTES IFRS",
  box2Text:
    "Nos professionnels expérimentés apportent une expertise approfondie dans les transitions IFRS, l'adoption de nouvelles normes, les transactions complexes et divers traitements comptables.",
  image: "/assets/images/TeamMeeting.png",
};

export const otherAssuranceServiceDataFR = {
  subtitle: "À PROPOS DE CE SERVICE",
  title: "RENFORCER LA CONFIANCE AU-DELÀ DES ÉTATS FINANCIERS",
  rightText:
    "Nous évaluons les systèmes, les contrôles et les indicateurs de performance qui influencent l'intégrité, la conformité et la qualité des rapports.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Nous évaluons les systèmes, les contrôles et les indicateurs de performance qui influencent l'intégrité opérationnelle, la conformité et la qualité des rapports.",
  box2Title: "NOS PROFESSIONNELS EXPÉRIMENTÉS",
  box2Text:
    "Nos spécialistes combinent l'expertise sectorielle avec une expérience approfondie de l'assurance pour évaluer les processus avec précision, identifier les lacunes et fournir des résultats clairs.",
  image: "/assets/images/TeamMeeting.png",
};

export const internalControlFrameworkDataFR = {
  subtitle: "POURQUOI DES CONTRÔLES SOLIDES SONT IMPORTANTS",
  title: "PARCE QUE LE RISQUE SURGIT LÀ OÙ LES CONTRÔLES NE SONT PAS",
  rightText:
    "Nous concevons des environnements de contrôle qui reflètent les processus réels, les rôles réels et les risques réels - jamais des hypothèses théoriques.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Nous concevons des environnements de contrôle qui reflètent les processus réels, les rôles réels et l'exposition aux risques réels, pas des hypothèses théoriques.",
  box2Title: "NOS SPÉCIALISTES EXPÉRIMENTÉS",
  box2Text:
    "Nous identifions les inefficacités, automatisons les contrôles lorsque c'est possible et transformons la gouvernance en une force évolutive plutôt qu'en un fardeau de conformité.",
  image: "/assets/images/TeamMeeting.png",
};

// ADVISORY SERVICES
export const dealAdvisoryDataFR = {
  subtitle: "COMPRENDRE LA VALEUR AU-DELÀ DES CHIFFRES",
  title: "STRUCTURATION D'AFFAIRES, STRATÉGIE M&A ET CLARTÉ COMMERCIALE",
  rightText:
    "Nous analysons la viabilité commerciale, prévoyons la hausse de valeur et découvrons les risques qui influencent votre décision finale, vous aidant à négocier en toute confiance.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Nous analysons la viabilité commerciale, prévoyons la hausse de valeur et découvrons les risques qui influencent votre décision finale, vous aidant à négocier en toute confiance.",
  box2Title: "NOTRE APPROCHE CONSULTATIVE",
  box2Text:
    "Nos experts combinent l'analyse financière et l'intuition industrielle pour vous aider à identifier les bonnes cibles, débloquer les synergies et sortir à la meilleure valorisation.",
  image: "/assets/images/TeamMeeting.png",
};

export const restructuringDataFR = {
  subtitle: "RESTRUCTURATION AVEC DISCIPLINE",
  title: "QUAND UNE ENTREPRISE A BESOIN DE PLUS QUE D'OPTIMISME",
  rightText:
    "Nous intervenons lorsque la croissance ralentit, la dette s'accumule, les marges rétrécissent et la prise de décision devient réactive en construisant un plan de redressement fondé sur des chiffres, pas sur l'espoir.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Nous intervenons lorsque la croissance ralentit, la dette s'accumule, les marges rétrécissent et la prise de décision devient réactive en construisant un plan de redressement fondé sur des chiffres, pas sur l'espoir.",
  box2Title: "NOS SPÉCIALISTES EN RESTRUCTURATION",
  box2Text:
    "Nous équilibrons les attentes des créanciers, l'urgence de trésorerie, l'impact sur la main-d'œuvre et la continuité des affaires pour stabiliser les opérations avant de piloter la récupération à long terme.",
  image: "/assets/images/TeamMeeting.png",
};

export const dueDiligenceDataFR = {
  subtitle: "POURQUOI LA DILIGENCE RAISONNABLE EST IMPORTANTE",
  title: "LES DÉCISIONS SONT AUSSI SOLIDES QUE L'INFORMATION",
  rightText:
    "Nous décodons les réalités financières, validons les fondamentaux commerciaux, testons les hypothèses et découvrons les signaux d'alarme tôt - pour que la confiance ne coûte pas cher plus tard.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Nous décodons les réalités financières, validons les fondamentaux commerciaux, testons les hypothèses et découvrons les signaux d'alarme tôt - pour que la confiance ne coûte pas cher plus tard.",
  box2Title: "ÉVALUATION INDÉPENDANTE EN LAQUELLE VOUS POUVEZ AVOIR CONFIANCE",
  box2Text:
    "Nos experts n'écrèment pas les données; ils les interrogent. Chaque chiffre, affirmation et projection est testé sous contrainte pour révéler la vérité, pas la théorie.",
  image: "/assets/images/TeamMeeting.png",
};

export const forensicServicesDataFR = {
  subtitle: "À PROPOS DES SERVICES FORENSIQUES",
  title: "DÉCOUVRIR LA FRAUDE ET LES FAUSSES DÉCLARATIONS FINANCIÈRES",
  rightText:
    "Nous examinons les dossiers financiers, menons des entretiens, accédons aux journaux numériques et reconstruisons les événements pour comprendre ce qui s'est passé, quand et comment.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Nous examinons les dossiers financiers, menons des entretiens, accédons aux journaux numériques et reconstruisons les événements pour comprendre ce qui s'est passé, quand et comment.",
  box2Title: "NOS SPÉCIALISTES FORENSIQUES",
  box2Text:
    "Professionnels formés à l'enquête, à la conformité et aux audits assistés par la technologie pour détecter les schémas de fraude avant qu'ils ne deviennent des pertes menaçant l'entreprise.",
  image: "/assets/images/TeamMeeting.png",
};

export const riskAdvisoryDataFR = {
  subtitle: "À PROPOS DU CONSEIL EN RISQUES",
  title: "NOUS TRANSFORMONS L'INCERTITUDE EN CONSCIENCE STRATÉGIQUE",
  rightText:
    "Notre pratique de conseil en risques examine les processus, l'exposition réglementaire, les lacunes opérationnelles, les vulnérabilités cyber et l'impact financier pour découvrir les menaces.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Notre pratique de conseil en risques examine les processus, l'exposition réglementaire, les lacunes opérationnelles, les vulnérabilités cyber et l'impact financier pour découvrir les menaces.",
  box2Title: "NOS EXPERTS EN RISQUES",
  box2Text:
    "Professionnels avec une exposition inter-industrielle qualifiés dans les cadres de risque d'entreprise, les contrôles, les tests de résistance et la préparation à la réponse.",
  image: "/assets/images/TeamMeeting.png",
};

export const technologyAdvisoryServiceDataFR = {
  subtitle: "À PROPOS DU CONSEIL TECHNOLOGIQUE",
  title: "TECHNOLOGIE QUI FONCTIONNE AVEC VOTRE ENTREPRISE",
  rightText:
    "Nous décodons les défis technologiques, cartographions les inefficacités, modernisons l'architecture héritée et alignons les dépenses technologiques sur les valeurs de l'entreprise.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Nous décodons les défis technologiques, cartographions les inefficacités, modernisons l'architecture héritée et alignons les dépenses technologiques sur les valeurs de l'entreprise.",
  box2Title: "NOS EXPERTS TECHNOLOGIQUES",
  box2Text:
    "Stratèges expérimentés en transformation numérique, sélection ERP, migration cloud, cadres de cybersécurité, automatisation des processus et modèles de décision basés sur les données.",
  image: "/assets/images/TeamMeeting.png",
};

export const valuationsDataFR = {
  subtitle: "NOTRE EXPERTISE EN ÉVALUATION",
  title: "DÉCISIONS SOLIDES ET TRANSACTIONS CONFIANTES",
  rightText:
    "Nous décodons les flux de revenus, l'exposition aux risques, la résilience des flux de trésorerie et la dynamique du marché pour présenter une valorisation qui reflète la vraie force commerciale.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Nous décodons les flux de revenus, l'exposition aux risques, la résilience des flux de trésorerie et la dynamique du marché pour présenter une valorisation qui reflète la vraie force commerciale.",
  box2Title: "NOS SPÉCIALISTES EN ÉVALUATION",
  box2Text:
    "Nos experts appliquent des modèles d'évaluation mondialement reconnus et une analyse basée sur des scénarios, garantissant que chaque chiffre est prêt pour l'audit et solide pour la négociation.",
  image: "/assets/images/TeamMeeting.png",
};
// ===============================
// FRENCH TRANSLATIONS - PART 2
// Continue in same file: AboutSec3DataFR.js
// ===============================

// TAXATION SERVICES
export const corporateTaxDataFR = {
  subtitle: "MAÎTRISER LA STRATÉGIE FISCALE",
  title: "FISCALITÉ D'ENTREPRISE CONÇUE POUR PROTÉGER ET DÉVELOPPER",
  rightText:
    "Nous ne calculons pas seulement des chiffres; nous identifions les positions fiscales, les incitations, les avenues de restructuration et les voies de déduction qui réduisent activement votre charge fiscale.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Nous ne calculons pas seulement des chiffres; nous identifions les positions fiscales, les incitations, les avenues de restructuration et les voies de déduction qui réduisent activement votre charge fiscale.",
  box2Title: "NOS SPÉCIALISTES FISCAUX",
  box2Text:
    "Nos conseillers fiscaux d'entreprise ont une expérience multi-industrielle, garantissant que chaque décision est soutenue par une interprétation juridique, une prévoyance des risques et une documentation structurée.",
  image: "/assets/images/TeamMeeting.png",
};

export const mergerAndAcquisitionDataFR = {
  subtitle: "COMPRENDRE LES FUSIONS ET ACQUISITIONS",
  title: "FUSIONS ET ACQUISITIONS FISCALEMENT EFFICACES",
  rightText:
    "Nous évaluons les acquisitions, les cessions et les réorganisations à travers un prisme fiscal afin qu'aucune responsabilité cachée ne surgisse plus tard.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Nous évaluons les acquisitions, les cessions et les réorganisations à travers un prisme fiscal afin qu'aucune responsabilité cachée ne surgisse plus tard.",
  box2Title: "NOTRE EXPERTISE FISCALE",
  box2Text:
    "Nos consultants ont travaillé dans plusieurs secteurs, nous donnant une prévoyance dans les défis de conformité et les modèles d'intégration qui protègent les résultats financiers.",
  image: "/assets/images/TeamMeeting.png",
};

export const transferPricingDataFR = {
  subtitle: "COMPRENDRE LES PRIX DE TRANSFERT",
  title: "TARIFICATION FISCALEMENT EFFICACE POUR LES TRANSACTIONS MONDIALES",
  rightText:
    "Nous analysons les relations entre entités mondiales, les fonctions, les droits et l'allocation des risques pour concevoir une tarification qui résiste aux audits et à la réalité économique.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Nous analysons les relations entre entités mondiales, les fonctions, les droits et l'allocation des risques pour concevoir une tarification qui résiste aux audits et à la réalité économique.",
  box2Title: "NOS EXPERTS EN PRIX DE TRANSFERT",
  box2Text:
    "Nous comparons le comportement du marché comparable, structurons la documentation selon les réglementations OCDE/économiques et soutenons la représentation à travers les juridictions.",
  image: "/assets/images/TeamMeeting.png",
};

export const valueAddedTaxDataFR = {
  subtitle: "APERÇU DU SERVICE",
  title: "CONSEIL TVA BASÉ SUR LA LÉGISLATION",
  rightText:
    "Nous traduisons les lois sur la TVA en cadres prêts pour les entreprises - des enregistrements et de la cartographie de la chaîne d'approvisionnement à l'éligibilité au taux zéro.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Nous traduisons les lois sur la TVA en cadres prêts pour les entreprises - des enregistrements et de la cartographie de la chaîne d'approvisionnement à l'éligibilité au taux zéro.",
  box2Title: "NOS SPÉCIALISTES FISCAUX",
  box2Text:
    "Travailler dans tous les secteurs, y compris le commerce de détail, le commerce, la logistique, le commerce électronique, la fabrication et l'immobilier, garantissant une mise en œuvre conforme.",
  image: "/assets/images/TeamMeeting.png",
};

export const internationalTaxDataFR = {
  subtitle: "FISCALITÉ MONDIALE. PRÉCISION LOCALE.",
  title: "NOUS APPORTONS DE LA STRUCTURE À LA FISCALITÉ TRANSFRONTALIÈRE",
  rightText:
    "Nous soutenons les entreprises mondiales avec des cadres fiscaux qui réduisent l'exposition, augmentent la certitude et s'alignent sur les normes internationales en évolution.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Nous soutenons les entreprises mondiales avec des cadres fiscaux qui réduisent l'exposition, augmentent la certitude et s'alignent sur les normes internationales en évolution.",
  box2Title: "NOS EXPERTS FISCAUX INTERNATIONAUX",
  box2Text:
    "Conseillers qualifiés dans les traités, les normes BEPS, l'évaluation de l'établissement stable et la conformité des transactions étrangères.",
  image: "/assets/images/TeamMeeting.png",
};

export const exciseTaxDataFR = {
  subtitle: "COMPRENDRE VOTRE CHARGE FISCALE",
  title: "CONFORMITÉ AUX ACCISES SANS ERREUR",
  rightText:
    "Nous décodons les règles d'accise pour votre secteur - carburants, tabac, produits liés au carbone ou articles à taux spécial, afin que la responsabilité devienne prévisible, pas écrasante.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Nous décodons les règles d'accise pour votre secteur - carburants, tabac, produits liés au carbone ou articles à taux spécial, afin que la responsabilité devienne prévisible, pas écrasante.",
  box2Title: "NOS SPÉCIALISTES EN ACCISES",
  box2Text:
    "Des années d'exposition réglementaire nous permettent de défendre votre position, de réduire les risques et de vous préparer aux audits avant qu'ils ne se produisent.",
  image: "/assets/images/TeamMeeting.png",
};

export const taxRestructuringDataFR = {
  subtitle: "RESTRUCTURER AVEC CLARTÉ",
  title: "MODÈLES FISCAUX QUI RÉDUISENT L'EXPOSITION ET RÉCUPÈRENT LA VALEUR",
  rightText:
    "Nous évaluons la structure de l'entité, le flux des transactions, les règles transfrontalières et les fuites fiscales - puis reconstruisons un système efficace, conforme et dimensionné pour l'avenir.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Nous évaluons la structure de l'entité, le flux des transactions, les règles transfrontalières et les fuites fiscales - puis reconstruisons un système efficace, conforme et dimensionné pour l'avenir.",
  box2Title: "NOS SPÉCIALISTES EN RESTRUCTURATION",
  box2Text:
    "Experts avec une exposition au domaine à travers les M&A, les structures de holding, la planification inter-juridictionnelle et les stratégies de reclassification pour des opérations fiscalement allégées.",
  image: "/assets/images/TeamMeeting.png",
};

export const economicSubstanceRegulationsDataFR = {
  subtitle: "CONÇU POUR LA PREUVE RÉGLEMENTAIRE",
  title: "DÉMONTRER UNE SUBSTANCE OPÉRATIONNELLE AUTHENTIQUE",
  rightText:
    "Nous examinons votre modèle d'affaires aux EAU, les contrôles du conseil d'administration, les flux de revenus et l'empreinte opérationnelle pour évaluer la conformité à la loi ESR.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Nous examinons votre modèle d'affaires aux EAU, les contrôles du conseil d'administration, les flux de revenus et l'empreinte opérationnelle pour évaluer la conformité à la loi ESR.",
  box2Title: "NOS EXPERTS EN CONFORMITÉ",
  box2Text:
    "Qualifiés dans les évaluations ESR, le dépôt, la notification, l'analyse des lacunes et la documentation au niveau du conseil d'administration qui reste solide lors de l'examen des autorités.",
  image: "/assets/images/TeamMeeting.png",
};

// BPO SERVICES
export const financeAndAccountingDataFR = {
  subtitle: "OÙ LA CLARTÉ RENCONTRE LE CONTRÔLE",
  title: "COMPTABILITÉ DE BOUT EN BOUT POUR DES SOLUTIONS RAPIDES",
  rightText:
    "Chez Pestel & Partners, nous rationalisons les comptes, automatisons les tâches quotidiennes, organisons le flux financier et garantissons que chaque chiffre atterrit là où il devrait.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Nous rationalisons les comptes, automatisons les tâches quotidiennes, organisons le flux financier et garantissons que chaque chiffre atterrit là où il devrait.",
  box2Title: "NOS COMPTABLES EXPÉRIMENTÉS",
  box2Text:
    "Une équipe formée pour fournir des livres prêts à l'audit, des rapports ultra-précis et une visibilité exploitable afin que vous ne perdiez jamais la trace de la trésorerie, des coûts ou de la conformité.",
  image: "/assets/images/TeamMeeting.png",
};

export const corporateAdvisoryServicesDataFR = {
  subtitle: "POURQUOI LE CONSEIL D'ENTREPRISE EST IMPORTANT",
  title: "LES DÉCISIONS INTELLIGENTES ONT BESOIN D'UNE PERSPECTIVE SOLIDE",
  rightText:
    "Chez Pestel & Partners, nous guidons les entreprises à travers des décisions qui impactent la structure du capital, l'expansion, les partenariats et la rentabilité à long terme.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Nous guidons les entreprises à travers des décisions qui impactent la structure du capital, l'expansion, les partenariats et la rentabilité à long terme.",
  box2Title: "NOS CONSEILLERS EXPÉRIMENTÉS",
  box2Text:
    "Des décennies de travail avec des entreprises régionales et mondiales nous rendent rapides à comprendre les défis, encore plus rapides à identifier les opportunités.",
  image: "/assets/images/TeamMeeting.png",
};

export const expensesClaimManagementDataFR = {
  subtitle: "VOTRE PARTENAIRE DE CONFIANCE POUR LES DÉPENSES",
  title: "UN SYSTÈME DE RÉCLAMATION CLAIR ET CONFORME",
  rightText:
    "Chez Pestel & Partners, nous rationalisons le flux de travail des dépenses organisationnelles avec des vérifications de validation précises et un suivi automatisé pour réduire les délais et rembourser les employés plus rapidement.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Nous rationalisons le flux de travail des dépenses organisationnelles avec des vérifications de validation précises et un suivi automatisé pour réduire les délais et rembourser les employés plus rapidement.",
  box2Title: "NOS SPÉCIALISTES EN DÉPENSES",
  box2Text:
    "Notre équipe apporte une expertise approfondie en conformité, documentation et contrôle des coûts, garantissant que chaque réclamation passe par une vérification robuste.",
  image: "/assets/images/TeamMeeting.png",
};

export const payrollHrServicesDataFR = {
  subtitle: "CE QUE CE SERVICE OFFRE",
  title: "ADMINISTRATION COMPLÈTE DE LA PAIE ET DES RH",
  rightText:
    "Chez Pestel & Partners, nous gérons tout, du traitement de la paie et de la conformité statutaire à la documentation RH, la gestion des avantages et l'administration des congés.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Nous gérons tout, du traitement de la paie et de la conformité statutaire à la documentation RH, la gestion des avantages et l'administration des congés.",
  box2Title: "NOS SPÉCIALISTES EN OPÉRATIONS HUMAINES",
  box2Text:
    "Nos professionnels expérimentés de la paie et des RH apportent une connaissance réglementaire approfondie, des processus sécurisés et un soutien fiable pour opérer avec confiance et cohérence.",
  image: "/assets/images/TeamMeeting.png",
};

export const secondmentDataFR = {
  subtitle: "EXTENSION STRATÉGIQUE DE LA MAIN-D'ŒUVRE",
  title: "EXPERTS À LA DEMANDE DANS VOTRE ÉQUIPE",
  rightText:
    "Chez Pestel & Partners, nous intégrons des professionnels qui stabilisent les processus, améliorent la qualité de sortie et s'intègrent dans vos flux de travail avec la responsabilité d'un employé interne et l'expertise d'un spécialiste externe.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Nous intégrons des professionnels qui stabilisent les processus, améliorent la qualité de sortie et s'intègrent dans vos flux de travail avec la responsabilité d'un employé interne et l'expertise d'un spécialiste externe.",
  box2Title: "NOS SPÉCIALISTES QUALIFIÉS",
  box2Text:
    "Chaque détaché est rigoureusement vérifié pour la capacité technique, l'adaptabilité et la maîtrise du secteur, garantissant qu'il peut assumer la responsabilité instantanément.",
  image: "/assets/images/TeamMeeting.png",
};

export const treasuryServiceDataFR = {
  subtitle: "QUI NOUS SOMMES",
  title: "UN PARTENAIRE DE TRÉSORERIE QUI COMPREND LA VOLATILITÉ",
  rightText:
    "Chez Pestel & Partners, nous créons des cadres de trésorerie qui aident les organisations à naviguer dans les changements de devises, les demandes de liquidité et les mouvements de trésorerie transfrontaliers.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Nous créons des cadres de trésorerie qui aident les organisations à naviguer dans les changements de devises, les demandes de liquidité et les mouvements de trésorerie transfrontaliers.",
  box2Title: "NOS SPÉCIALISTES EN TRÉSORERIE",
  box2Text:
    "Notre équipe apporte une expertise approfondie en banque, finance et conformité - garantissant que votre trésorerie fonctionne avec précision, prévoyance et contrôles internes solides.",
  image: "/assets/images/TeamMeeting.png",
};

// STRATEGIES
export const marketResearchDataFR = {
  subtitle: "COMMENT LA RECHERCHE DE MARCHÉ AIDE",
  title: "RECHERCHE STRATÉGIQUE POUR DE VRAIES DÉCISIONS COMMERCIALES",
  rightText:
    "Chez Pestel & Partners, nous combinons l'analyse de données, l'intelligence industrielle et la recherche sur le terrain pour aider les organisations à comprendre les marchés, les clients et les paysages concurrentiels.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Nous combinons l'analyse de données, l'intelligence industrielle et la recherche sur le terrain pour aider les organisations à comprendre les marchés, les clients et les paysages concurrentiels.",
  box2Title: "NOS SPÉCIALISTES EN RECHERCHE",
  box2Text:
    "Nos analystes, économistes et experts sectoriels décodent les tendances, quantifient les opportunités et découvrent les risques, vous permettant d'agir avec clarté, pas avec des suppositions.",
  image: "/assets/images/TeamMeeting.png",
};

export const businessConsultingDataFR = {
  subtitle: "NOTRE EXPERTISE STRATÉGIQUE",
  title: "CONSEIL PRATIQUE POUR LES DIRIGEANTS QUI ONT BESOIN DE RÉSULTATS",
  rightText:
    "Chez Pestel & Partners, nous aidons les équipes de direction à comprendre les marchés en évolution, les goulots d'étranglement opérationnels et les besoins changeants des clients - transformant l'incertitude en direction claire et exploitable.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Nous aidons les équipes de direction à comprendre les marchés en évolution, les goulots d'étranglement opérationnels et les besoins changeants des clients - transformant l'incertitude en direction claire et exploitable.",
  box2Title: "NOS SPÉCIALISTES EN CONSEIL",
  box2Text:
    "Des décennies d'expertise inter-industrielle nous permettent de diagnostiquer ce qui freine votre croissance et de concevoir des cadres stratégiques construits autour de la force concurrentielle.",
  image: "/assets/images/TeamMeeting.png",
};

// CORPORATE SERVICES
export const entitySetupDataFR = {
  subtitle: "CONSTRUIT DÈS LE DÉBUT",
  title: "FORMATION D'ENTITÉ DE BOUT EN BOUT SANS APPROXIMATION",
  rightText:
    "Chez Pestel & Partners, nous transformons la complexité de la formation d'entité en un parcours clair et stratégique. Au lieu de vous noyer dans les réglementations, nous les décodons!",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Nous transformons la complexité de la formation d'entité en un parcours clair et stratégique. Au lieu de vous noyer dans les réglementations, nous les décodons!",
  box2Title: "NOS CONSEILLERS D'ENTREPRISE",
  box2Text:
    "Nos conseillers interviennent en tant que partenaires stratégiques, pas comme des processeurs de documents. Ils étudient comment vous prévoyez d'opérer, de vous développer, d'embaucher, de transiger et de vous développer à l'international.",
  image: "/assets/images/TeamMeeting.png",
};

export const outsourcedFinanceRegulatoryComplianceDataFR = {
  subtitle: "UNE COLONNE VERTÉBRALE FINANCIÈRE PLUS SOLIDE",
  title: "CONSTRUIT SUR LA PRÉCISION ET LA CONFORMITÉ CONTINUE",
  rightText:
    "Chez Pestel & Partners, nous prenons en charge la charge opérationnelle avec une approche basée sur le système qui maintient vos chiffres propres, opportuns et alignés.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Nous prenons en charge la charge opérationnelle avec une approche basée sur le système qui maintient vos chiffres propres, opportuns et alignés.",
  box2Title: "NOS EXPERTS RÉGLEMENTAIRES",
  box2Text:
    "Notre équipe surveille les lois en évolution, gère la documentation et garantit que votre entreprise ne manque jamais une obligation.",
  image: "/assets/images/TeamMeeting.png",
};

export const companySecretarialDataFR = {
  subtitle: "VOTRE COLONNE VERTÉBRALE DE GOUVERNANCE D'ENTREPRISE",
  title: "MAINTENIR VOTRE MAISON D'ENTREPRISE EN PARFAIT ORDRE",
  rightText:
    "Chez Pestel & Partners, nous gérons l'intégralité de votre cycle de vie de conformité d'entreprise - des incorporations et modifications aux registres, résolutions et dépôts réglementaires.",
  box1Title: "CHEZ PESTEL & PARTNERS",
  box1Text:
    "Nous gérons l'intégralité de votre cycle de vie de conformité d'entreprise - des incorporations et modifications aux registres, résolutions et dépôts réglementaires.",
  box2Title: "NOS SPÉCIALISTES EN GOUVERNANCE",
  box2Text:
    "Notre équipe apporte une expérience régionale pratique, une compréhension réglementaire approfondie et des compétences en documentation méticuleuse pour maintenir l'intégrité statutaire de votre entité.",
  image: "/assets/images/TeamMeeting.png",
};